module.exports = __webpack_public_path__ + "af9b65f8a1cbd1093c3c565ab34cb39e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/humanitix-purple.svg
// module id = qALj
// module chunks = 5